export default "__VITE_ASSET__BK$4sYCU__"